import { render, staticRenderFns } from "./dados-pessoa-component.vue?vue&type=template&id=08740b77&"
import script from "./dados-pessoa-component.vue?vue&type=script&lang=ts&"
export * from "./dados-pessoa-component.vue?vue&type=script&lang=ts&"
import style0 from "./dados-pessoa-component.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins-hml/workspace/pracessivel-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08740b77')) {
      api.createRecord('08740b77', component.options)
    } else {
      api.reload('08740b77', component.options)
    }
    module.hot.accept("./dados-pessoa-component.vue?vue&type=template&id=08740b77&", function () {
      api.rerender('08740b77', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pessoa/dados-pessoa-component.vue"
export default component.exports